import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "react-bootstrap";
import { FLUID_AT, STANDARD_SPACING } from "../config";
import { ERROR_ICON } from "../icons";
export default function ErrorPage(props) {
    return (_jsx("div", { className: "d-flex flex-grow-1 text-center align-items-center py-" + STANDARD_SPACING, children: _jsxs(Container, { fluid: FLUID_AT, children: [_jsx(FontAwesomeIcon, { ...ERROR_ICON, style: { fontSize: "10vh" } }), _jsx("h1", { className: "display-2 fw-bold my-" + STANDARD_SPACING, children: props.title }), props.children] }) }));
}
